import type {ReactNode} from "react";
import {Text} from "@/elements/text";
import {TitleWrapper} from "./styles";

const emojiRegex = /(\p{Emoji_Presentation}|\p{Emoji})/gu;

interface EmojiTextProps {
  title?: string;
  emoji?: ReactNode;
}

export const EmojiText = ({title, emoji}: EmojiTextProps) => {
  const processTitle = (text: string) => {
    return text.split(emojiRegex).map((part: string, index: number) => {
      if (emojiRegex.test(part)) {
        return (
          <span key={index} style={{fontSize: "1rem"}}>
            {part}
          </span>
        );
      }
      return (
        <Text
          key={index}
          type="tag"
          styles={{
            marginLeft: part.length && 8,
            position: "relative",
          }}
        >
          {part}
        </Text>
      );
    });
  };
  return (
    <TitleWrapper>
      <div style={{display: "flex", alignItems: "center"}}>
        {emoji ? (
          <>
            <span style={{fontSize: "1rem"}}>{emoji}</span>
            <Text
              type="tag"
              styles={{marginLeft: title?.length && 8, position: "relative"}}
            >
              {title}
            </Text>
          </>
        ) : (
          // title is required in practice when emoji is absent (pre-existing assumption, unchanged)
          processTitle(title as string)
        )}
      </div>
    </TitleWrapper>
  );
};
